import { cn } from '@/lib/cn'

export interface RangeSliderProps {
  min: number
  max: number
  step?: number
  value: number
  onChange: (value: number) => void
  id?: string
  ariaLabel?: string
  className?: string
  disabled?: boolean
}

/**
 * Thin wrapper around a native range input - lets pages compose sliders
 * without tripping the ESLint no-raw-`<input>` rule in `pages/*`.
 */
export function RangeSlider({
  min,
  max,
  step = 1,
  value,
  onChange,
  id,
  ariaLabel,
  className,
  disabled,
}: RangeSliderProps) {
  return (
    <input
      type="range"
      id={id}
      min={min}
      max={max}
      step={step}
      value={value}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(e) => onChange(Number(e.target.value))}
      className={cn(
        'h-2 w-full cursor-pointer appearance-none rounded-pill bg-muted accent-primary',
        className,
      )}
    />
  )
}
